export default "__VITE_ASSET__DEsgxB$o__"